import styled from 'styled-components';
import { IBalance, IRow } from './interface';

const frame = styled.table`
  table-layout: fixed;
  margin-top: 1.5rem;
  width: 100%;
`;

const head = styled.tr`
  width: 100%;
  border-bottom: 0.125rem solid #666666;
`;

const headerRow = styled.thead`
  width: 100%;
`;

const label = styled.th`
  text-align: center;
  font-size: 1rem;
`;

const body = styled.tbody`
  text-align: center;
  width: 100%;
`;

const balance = styled.td<IBalance>`
  padding: 0 0.25rem;
  font-weight: 500;
  font-size: 1rem;
  text-align: center;
  color: ${(props) =>
    props.value !== undefined && props.value !== null && props.value < 0
      ? '#B83A30'
      : 'inherit'};
`;

const data = styled.td`
  padding: 0 0.25rem;
  text-align: center;
  font-weight: 500;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
`;

const id = styled.td`
  padding: 0 0.25rem;
  text-align: center;
  font-weight: 500;
  font-size: 1rem;
  width: 2rem;
`;

const row = styled.tr<IRow>`
  width: 100%;
  border-radius: 0.5rem;
  border-bottom: 0.125rem solid #666666;
  background-color: ${(props) => {
    switch (props.status) {
      case 2:
        return '#DEBE21';

      case 3:
        return '#F57620';

      case 4:
        return props.theme.colors.hoverRed;

      default:
        break;
    }

    if (props.closedAccount === 1) {
      return '#888888';
    }
    return 'white';
  }};

  &:hover {
    background-color: ${(props) => {
      switch (props.status) {
        case 2:
          return '#b39919';

        case 3:
          return '#DE8112';

        case 4:
          return props.theme.colors.red;

        default:
          break;
      }
      if (props.closedAccount === 1) {
        return '#686868';
      }
      return '#CEcECE';
    }};
  }
`;

const TableComponent = {
  Frame: frame,
  Head: head,
  Label: label,
  Body: body,
  Balance: balance,
  Data: data,
  Id: id,
  Row: row,
  HeaderRow: headerRow,
};

export default TableComponent;
